import { alpha, Box, Paper, Stack, Typography } from "@mui/material";

export const SectionHeader = ({ icon, color = '#159073', title, subtitle, right }) => (
  <Stack direction="row" alignItems="center" spacing={1.5} sx={{ p: 2, pb: 1.5 }}>
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: 1.5,
        display: 'grid',
        placeItems: 'center',
        color,
        bgcolor: alpha(color, 0.14),
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ minWidth: 0, flexGrow: 1 }}>
      <Typography variant="subtitle1" fontWeight={700} noWrap>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" noWrap display="block">
          {subtitle}
        </Typography>
      )}
    </Box>
    {right}
  </Stack>
);


export const Section = ({ children, sx, ...rest }) => (
  <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden', ...sx }} {...rest}>
    {children}
  </Paper>
);

